// @tennis-matches/services/trainerstunden/billing-cancelled-session-release
// Nach Storno: Session-Positionen auf stornierten Rechnungen freigeben, wenn dieselben Stunden
// auf einem neuen aktiven Entwurf liegen (Reaktivierungs-Konflikt vermeiden).

function __asStr(x) {
  return String(x ?? "").trim();
}

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {{
 *   items?: Array<{ session_id?: string, person_id?: string, created_by?: string }>,
 *   excludeStatementId?: string,
 * }} args
 */
export async function releaseCancelledBillingSessionItemsForNewDraft(supabase, args = {}) {
  const sb = supabase;
  if (!sb) return { ok: false, reason: "missing-supabase" };

  const excludeId = __asStr(args.excludeStatementId);
  const lines = Array.isArray(args.items) ? args.items : [];
  const pairs = new Map();
  for (const it of lines) {
    const sessionId = __asStr(it?.session_id);
    const personId = __asStr(it?.person_id);
    const createdBy = __asStr(it?.created_by);
    if (!sessionId || !personId || !createdBy) continue;
    pairs.set(`${sessionId}|${personId}|${createdBy}`, { sessionId, personId, createdBy });
  }
  if (!pairs.size) return { ok: true, released: 0 };

  let released = 0;
  for (const { sessionId, personId, createdBy } of pairs.values()) {
    const { data: itemRows, error: itemErr } = await sb
      .from("trainerstunden_billing_statement_items")
      .select("id, statement_id")
      .eq("kind", "session")
      .eq("session_id", sessionId)
      .eq("person_id", personId)
      .eq("created_by", createdBy);
    if (itemErr) return { ok: false, error: itemErr };

    const candidates = (Array.isArray(itemRows) ? itemRows : []).filter(
      (r) => __asStr(r?.statement_id) && __asStr(r.statement_id) !== excludeId
    );
    if (!candidates.length) continue;

    const stmtIds = [...new Set(candidates.map((r) => __asStr(r.statement_id)).filter(Boolean))];
    const { data: stmts, error: stErr } = await sb
      .from("trainerstunden_billing_statements")
      .select("id,status")
      .in("id", stmtIds);
    if (stErr) return { ok: false, error: stErr };

    const cancelledIds = new Set(
      (Array.isArray(stmts) ? stmts : [])
        .filter((s) => __asStr(s?.status) === "cancelled")
        .map((s) => __asStr(s.id))
    );
    const idsToRelease = candidates
      .filter((r) => cancelledIds.has(__asStr(r.statement_id)))
      .map((r) => __asStr(r.id))
      .filter(Boolean);
    if (!idsToRelease.length) continue;

    const { error: updErr } = await sb
      .from("trainerstunden_billing_statement_items")
      .update({ session_id: null })
      .in("id", idsToRelease);
    if (updErr) return { ok: false, error: updErr };
    released += idsToRelease.length;
  }

  return { ok: true, released };
}
